import { jsx as _jsx } from "react/jsx-runtime";
import { UkBiobankMethodsInternal, UkBiobankMethodsPublic, } from './components';
const UkBiobankMethodsSection = ({ isPublic = false, }) => (isPublic
    ? _jsx(UkBiobankMethodsPublic, {}, void 0)
    : _jsx(UkBiobankMethodsInternal, {}, void 0));
export default UkBiobankMethodsSection;
